import "../node_modules/@techsharegov/react-ui/dist/theme/style.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

declare global {
  interface Window {
    API_ENDPOINT: string;
    VERSION_NUMBER: string;
    BASE_URL: string;
    ENVIRONMENT_NAME: string;
    FILE_UPLOAD_CHUNK_SIZE: string;
    DWT_ORGANIZATION_ID: string;
    REDIRECT_URI: string;
  }
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
